angular.module('invoice')
    .service('BgtGroupingService', function (InvoiceService) {
        this.sumAmounts = (items) => {
            let amounts = (items || [])
                .map(item => item && item.amount)
                .filter(amount => amount != null && !isNaN(amount));
            return InvoiceService.sumDecimal(amounts);
        };

        this.groupItemsByParent = (items) => {
            let grouped = {};
            (items || []).forEach(item => {
                let group = item && item.group;
                if (group) {
                    let parent = group.parent || group;
                    if (!grouped[parent.id]) {
                        grouped[parent.id] = {
                            parent: parent,
                            children: []
                        };
                    }
                    grouped[parent.id].children.push(item);
                }
            });
            return grouped;
        };

        this.sumGroupAmounts = (grouped) => {
            return this.sumAmounts((grouped && grouped.children) || []);
        };

        this.sumAmountsByCurrency = (items) => {
            let totals = {};
            (items || []).forEach(item => {
                if (!item || item.amount == null || isNaN(item.amount) || !item.currency) {
                    return;
                }
                totals[item.currency] = InvoiceService.sumDecimal([totals[item.currency] || 0, item.amount]);
            });
            return Object.keys(totals).sort().map(currency => ({currency: currency, amount: totals[currency]}));
        };
    })
    .factory('InvoiceBgt', function ($resource) {
        return $resource('crm/api/invoice/:entityId/bgt/:id', { }, {
            'query': { method: 'GET', isArray: true },
            'get': { method: 'GET' },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'delete': { method: 'DELETE' },
            'summary': {method: 'POST', url: '/crm/api/invoice-bgt/summary'}
        });
    })
    .service('InvoiceBgtService', function ($rootScope, $cookies, toastr, modals, Principal, InvoiceBgt) {
        this.add = (entityId, totalLeft, invoiceTotal, currency) => {
            let entity = {
                entityId: entityId,
                totalLeft: totalLeft,
                invoiceTotal: invoiceTotal,
                currency: currency
            }
            return modals.open('app/invoice/bgt/edit-position.html', 'InvoiceBgtEditPositionController', entity, {size: "sm"}, "$ctrl")
        }
        this.edit = (entityId, item, totalLeft, invoiceTotal, currency) => {
            let entity = {
                entityId: entityId,
                item: item,
                totalLeft: totalLeft,
                invoiceTotal: invoiceTotal,
                currency: currency
            }
            return modals.open('app/invoice/bgt/edit-position.html', 'InvoiceBgtEditPositionController', entity, {size: "sm"}, "$ctrl")
        }
        this.delete = (entityId, item) => {
            return modals.confirmDelete("wybraną pozycję", () => InvoiceBgt.delete({entityId: entityId, id: item.id}).$promise)
        }
    })
